import FormSelectInput from 'components/forms/elements/FormSelectInput'
import FormTextInput from 'components/forms/elements/FormTextInput'
import { generateSelectOptions } from 'utils/ApiHelpers'

const content = ({ events, formDisabled, updateField }) => [
  {
    id: 'search-participants-form',
    name: 'Search Participants',
    inputs: [
      {
        id: 'eventId',
        size: { xs: 12, md: 6 },
        field: (
          <FormSelectInput
            name="eventId"
            label="Event"
            autoComplete="new-eventId"
            disabled={formDisabled}
            placeholder="Select Event"
            options={generateSelectOptions(events)}
            required
          />
        ),
      },
      {
        id: 'email',
        size: { xs: 12, md: 6 },
        field: (
          <FormTextInput
            name="email"
            label="Email Address"
            required
            autoComplete="new-email"
            disabled={formDisabled}
            onModified={(e) => {
              updateField('email', e.target.value.toUpperCase().trim())
            }}
          />
        ),
      },
    ],
  },
]

export default content
